<script setup>
import {onMounted, ref, watch} from 'vue'
import Multiselect from '@vueform/multiselect'

const props = defineProps([
    'options',
    'label',
    'id',
    'noResultsText',
    'canClear',
    'name',
    'selectedValue',
    'mode',
    'readonly',
    'closeOnSelect'
])

const value = ref(null)

onMounted(() => {
    if (!props.mode || !props.mode.length) {
        props.mode = 'tags'
    }
    if (!props.readonly || !props.readonly.length) {
        props.readonly = false
    }
    value.value = props.selectedValue
})

</script>

<template>
    <div class="input-holder">
        <label :for="id">{{ label }}</label>
        <Multiselect v-model="value"
                    :options="options"
                    :can-clear="canClear"
                    :no-results-text="noResultsText"
                    :mode="mode"
                    :close-on-select="closeOnSelect"
                    :disabled="readonly"
        />
        <input type="hidden" :name="name" :value="value">
    </div>
</template>
